export default [
  {
    path: '/data-management/list/:ref',
    name: 'data-management-list',
    component: () =>
      import(
        '@/views/pages/data-management/data-management-list/DataManagementList.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Data Management',
      },
      {
        text: 'Customer',
        active: true,
      },
    ],
  },
  {
    path: '/data-management/detail/:ref',
    name: 'data-management-detail',
    component: () =>
      import(
        '@/views/pages/data-management/data-management-detail/DataManagementDetail.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Data Management',
      },
      {
        text: 'Customer',
      },
      {
        text: 'Detail',
        active: true,
      },
    ],
  },
  {
    path: '/data-management/summary/:ref',
    name: 'data-management-summary',
    component: () =>
      import(
        '@/views/pages/data-management/data-management-summary/DataManagementSummary.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Data Management',
      },
      {
        text: 'Summary Dashboard',
        active: true,
      },
    ],
  },
];
